import angular from 'angular';
import portaro from '../portaro';
import KpUniversalForm from '../commons/value-editors/kp-universal-form/KpUniversalForm.svelte';

portaro.controller('PaymentFormCtrl', ['$scope', 'paymentDataService', 'amountTypeDataService',
    function($scope, paymentDataService, amountTypeDataService) {

        function FrontentPaymentRequestItem(amount, direct, withContraDebt) {
            angular.extend(this, amount);

            this.enabled = true;

            this.direct = direct;

            this.withContraDebt = withContraDebt;

            this.getMaxSum = function () {
                if (this.direct || this.type.creditable) {
                    return 999999;
                }
                return amount.sum; //we must use amount.sum, not this.sum to preserve original value
            };

            this.isSendable = function () {
                return this.enabled && this.sum > 0;
            }
        }


        $scope.kpUniversalFormComponent = KpUniversalForm;

        $scope.init = async function(formPackage, submitPromise) {
            $scope.formPackage = formPackage;
            $scope.formPackage.formObject.amounts = $scope.formPackage.formObject.amounts.map((amount) => new FrontentPaymentRequestItem(amount, false, false));
            $scope.typesEditable = formPackage.typesEditable;
            $scope.sumsEditable = formPackage.sumsEditable;
            $scope.submitPromise = submitPromise;
            $scope.amountTypes = await amountTypeDataService.getAll();
        };


        $scope.submit = function() {
            if (!$scope.isSubmittable()) {
                return;
            }
            const payRequest = {
                provider: $scope.formPackage.formObject.provider,
                payer: $scope.formPackage.formObject.payer,
                department: $scope.formPackage.formObject.department,
                itemsSpec: $scope.formPackage.formObject.itemsSpec,
                amounts: $scope.formPackage.formObject.amounts.filter((item) => item.isSendable())
            };
            $scope.submitPromise(paymentDataService.pay(payRequest));
        };


        $scope.getTotalSum = function() {
            return $scope.formPackage.formObject.amounts
                .filter((amount) => amount.isSendable())
                .reduce((acc, amount) => acc + amount.sum, 0);
        };


        $scope.isSubmittable = function() {
            return $scope.formPackage.formObject.amounts.some((item) => item.isSendable());
        };


        $scope.addDirectPayment = function() { //prima platba
            const amount = {
                owner: $scope.formPackage.formObject.itemsSpec.directPaymentOwner,
                sum: 0,
                type: $scope.amountTypes[0],
            };
            $scope.formPackage.formObject.amounts.push(new FrontentPaymentRequestItem(amount, true, true));
        };

    }]);
